<gp-modal-frame
  class="modal-frame"
  [icon]="icon"
  [hasCloseButton]="hasCloseButton"
  [size]="width"
  (close-overlay)="onClose($any($event))"
>
  <h3 *ngIf="!!header" slot="header">{{ header }}</h3>
  <div *ngIf="hasSticky" slot="sticky" class="sticy-container">
    <ng-content select="[sticky]"></ng-content>
  </div>
  <div class="content-container">
    <ng-content></ng-content>
  </div>
  <div
    *ngIf="hasFooter"
    slot="footer"
    class="footer-container"
    [class.footer-container--divider]="footerDivider"
  >
    <ng-content select="[footer]"></ng-content>
    <div class="actions-container" [class.actions-container--alt-theme]="altTheme">
      <ng-container *ngIf="!altTheme; else altThemeActions">
        <button
          *ngIf="submitButtonLabel"
          data-cy="submit-button"
          class="submit-button"
          ene-filled-button
          size="large"
          [type]="submitForm ? 'submit' : 'button'"
          [attr.form]="submitForm"
          [disabled]="submitDisabled"
          (click)="onSubmit()"
        >
          {{ submitButtonLabel }}
        </button>
        <button
          *ngIf="closeButtonLabel"
          data-cy="close-button"
          class="close-button"
          ene-outline-button
          size="large"
          (click)="onClose()"
        >
          {{ closeButtonLabel }}
        </button>
      </ng-container>
      <ng-template #altThemeActions>
        <tpm-button *ngIf="closeButtonLabel" button-outline button-rounded data-cy="close-button" (click)="onClose()">
          {{ closeButtonLabel }}
        </tpm-button>
        <tpm-button
          *ngIf="submitButtonLabel"
          button-filled
          button-rounded
          data-cy="submit-button"
          [attr.type]="submitForm ? 'submit' : 'button'"
          [attr.form]="submitForm"
          [disabled]="submitDisabled"
          (click)="onSubmit()"
        >
          {{ submitButtonLabel }}
        </tpm-button>
      </ng-template>
    </div>
  </div>
</gp-modal-frame>
